import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "@phosphor-icons/react";
import { FAQS } from "../data";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="section bg-[#050505]">
      <div className="container-pd">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-5">
              <div className="divider-gold" />
              <span className="eyebrow">07 · FAQ</span>
            </div>
            <h2 className="font-display font-black text-white text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-[1.05]">
              Common questions.
            </h2>
            <p className="mt-5 text-zinc-400 leading-relaxed">
              Don&apos;t see yours? Drop it in the quote form notes — we&apos;ll cover it before booking.
            </p>
          </div>

          <div className="lg:col-span-8 border-t border-white/5">
            {FAQS.map((item, i) => {
              const isOpen = open === i;
              return (
                <div key={i} className="border-b border-white/5" data-testid={`faq-item-${i}`}>
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    data-testid={`faq-toggle-${i}`}
                    className="w-full text-left py-6 flex items-center justify-between gap-6 group"
                  >
                    <span className="font-display text-lg sm:text-xl text-white font-medium group-hover:text-[#D4AF37] transition-colors">
                      {item.q}
                    </span>
                    <span className="text-[#D4AF37] shrink-0">
                      {isOpen ? <Minus size={20} weight="bold" /> : <Plus size={20} weight="bold" />}
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="overflow-hidden"
                      >
                        <p className="pb-6 pr-8 text-zinc-400 leading-relaxed">{item.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
